import IMask from 'imask'

export default {

    init() {
        this.email();
        this.phone();
        this.names();
        this.zipcode();
        this.address();
        this.state();
        this.cvv();
        this.card();
        this.expdate();
        this.routingNumber();
        this.accountNumber();
        this.promoCode();
        this.choosePhone();
        this.verificationCode();
        this.businessRegistrationNumber();
    },

    email() {
        $('[name=email]').mask("A", {
            translation: { "A": { pattern: /[\w@\-.+]/, recursive: true} }
        });
    },

    phone() {
        $('[name=phone], [name=cellphone_number], [name=businessContactPhone]')
            .mask('000-000-0000', {placeholder: '___-___-____'});
        $('[name=phone], [name=cellphone_number], [name=businessContactPhone]').off('paste').on('paste', function(e) {
            e.preventDefault();
            let pastedData = e.originalEvent.clipboardData.getData('Text');
            let digits = pastedData.replace(/\D/g, '');
            if (digits.length > 10) {
                digits = digits.slice(-10);
            }
            $(this).val(digits);
            $(this).trigger('input');
        });
    },

    names() {
        $('[name=first_name]').mask("A", {
            translation: {"A": { pattern: /\w+/, recursive: true}}
        });
        $('[name=last_name]').mask("A", {
            translation: {"A": { pattern: /\w+/, recursive: true}}
        });
        $('[name=vendor_name]').mask("A", {
            translation: {"A": { pattern: /[\s\w]+/, recursive: true}}
        });
    },

    zipcode() {
        $('[name=zip_code]').mask('00000', {placeholder: '_____'});
    },

    cvv(){
        $('[name=cvc]').mask('0000', {placeholder:'____'});
    },

    expdate(){
        $('[name=expiration_date]').not('[hidden]').mask('00/00', {placeholder: '__/__'});
    },

    state(){
        $('[type="text"][name=state]').mask("AA", {
            translation: {"A": { pattern: /[A-z]{1}/}}
        });
    },

    address() {
        $('[name=address]').mask("A", {
            translation: {"A": { pattern: /./, recursive: true}}
        });
    },

    card(){
        $('[name=card_number]').mask("A", {
            translation: {"A": { pattern: /[0-9]/, recursive: true}}
        });
    },

    routingNumber() {
        $('[name=routing_number]').mask('999999999', { placeholder: '_________'});
    },

    accountNumber() {
        $('[name=account_number]').mask('999999999999', { placeholder: '____________'});
    },

    promoCode(){
        // $('#promo_code').mask('AAAA-AAAA-AAAA-AAAA', {
        //     translation: {"A": { pattern: /[0-9A-Z]{0,1}/}},
        //     placeholder: 'XXXX-XXXX-XXXX-XXXX'
        // });
        if (typeof (Inputmask) === 'function') {
            $('#promo_code').inputmask({
                mask: "*{1,50}",
                greedy: false,
                definitions: {
                    '*': {
                      validator: "[0-9A-Za-z_\-]",
                      casing: "upper"
                    }
                }
            });
        }
    },

    choosePhone(){
        $('[name=area_code]').mask('(000)');
        $('[name=search_phone_number]').mask('0000000');
    },

    verificationCode(){
        $('#multifactor-verification-code').mask('000000');
    },

    maskNumber(ev){
        let value = $(ev.currentTarget).val()
        if (/[^0-9\.]*/.test(value))
            value = value.replace(/[^0-9\.]*/g, '')
        if (value.toString().match(/[.]/g)?.length > 1 || /\.\d{3,}/.test(value))
            value = value.substring(0, value.length - 1)
        $(ev.target).val(value)
    },

    maskInteger(ev){
        let value = $(ev.currentTarget).val()
        if (/[^0-9]*/.test(value))
            value = value.replace(/[^0-9]*/g, '')
        $(ev.target).val(value)
    },

    businessRegistrationNumber() {
        $('#businessRegistrationNumber').mask('000000000');
    }
}
